<template>
  <div>
    <div>
      <!-- <DropDown class="dealer-table-dropdown" :item="DealerField" :inputType="InputType" :options="DealerTerritoryOptions"
        @dropdown-func="handleSearchResultClick" @edit-type="handleEditInputType" />
      <DataInput class="dealer-table-data-input" :dataInput="searchItem" type="text" @inputValue="handleInputValue" /> -->
    </div>
    <div class="territory-table-overlay-cont">
      <table class="tf-table">
        <thead>
          <tr class="tf-table-header-row">
            <th class="tf-header-text-title" v-for="item in TerritoryTableHeaders" :key="item.id"
              :class="{ sortable: item.value !== 'active', 'sort-active': sortKey === item.value }"
              @click="item.value !== 'active' && handleSort(item.value)">
              {{ item.title }}
              <span v-if="sortKey === item.value" class="sort-arrow">{{ sortDir === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th class="tf-header-text-edit">EDIT</th>
            <th class="tf-header-text-del">DELETE</th>
          </tr>
        </thead>
        <tbody>
          <tr class="tf-table-data-row" v-for="item in TerritoryItems" :id="'territory-row-' + item.territoryId">
            <td><input class="tf-table-data-checkbox" type="checkbox" v-model="item.isActive"
                @input="handleActiveStatus(item)"></td>
            <td>{{ item.manager }}</td>
            <td>{{ item.managerEmail }}</td>
            <td>{{ item.managerPhone }}</td>
            <td>{{ item.managerMobilePhone }}</td>
            <td>{{ item.managerSkype }}</td>
            <td>{{ item.managerWhatsApp }}</td>
            <td>
              <img @click="handleEditTerritory(item)" class="tf-table-data-edit-icon"
                :src="require('@/assets/svg/SVG/edit.svg')">
            </td>
            <td>
              <img @click="handleDeleteTerritory(item)" class="tf-table-data-delete-icon"
                :src="require('@/assets/svg/SVG/white_bg_x_gry_stroke.svg')">
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <Pagination :total-pages="TotalPages" :current-page="currentPage" @page-change="handlePageChange"></Pagination> -->
  </div>
</template>
<script>
import { useDealerStore } from '@/store/DealerStore';
import { useModalStore } from '@/store/ModalStore';
import Pagination from './Pagination.vue';
import DataInput from './DataInput.vue';
import DropDown from './DropDown.vue';
import gsap from 'gsap';
import { useTerritoryStore } from '@/store/TerritoryStore';
export default {
  data () {
    return {
      currentPage: 1,
      perPage: 30,
      searchItem: {
        field: 'dealer_search',
        label: 'Dealer Search',
        value: '',
        type: 'text',
        required: false,
      },
      territories: null,
      savedTerritories: null,
      filterField: {
        field: 'dealerName',
        label: 'Filter by Territory Manager',
        placeholder: 'Territory Manager',
        value: '',
        type: 'select',
        required: true,
      },
      dealerTerritories: null,
      removeTerritory: null,
      pastTerritory: null,
      sortKey: null,
      sortDir: 'asc'
    };
  },
  components: {
    Pagination,
    DataInput,
    DropDown
  },
  computed: {
    Territories () {
      const territoryStore = useTerritoryStore();
      this.savedTerritories = territoryStore.territories;
      this.territories = territoryStore.territories;
      return territoryStore.territories;
    },
    DealerField () {
      return this.filterField;
    },
    InputType () {
      return useTerritoryStore().inputType;
    },
    DealerTerritoryOptions () {
      if (this.dealerTerritories != null) {
        return this.dealerTerritories.map((item) => {
          return {
            id: item.territoryId,
            name: item.manager,
            value: item.territoryId
          };
        });
      }
    },
    DealerTerritories () {
      const dealerStore = useDealerStore();
      this.dealerTerritories = dealerStore.dealerTerritories;
      return dealerStore.dealerTerritories;
    },
    States () {
      const territoryStore = useTerritoryStore();
      return territoryStore.tmpStates;
    },
    TerritoryTableHeaders () {
      const territoryStore = useTerritoryStore();
      return territoryStore.territoryTableHeaders;
    },
    TotalPages () {
      if (this.Territories != null) {
        return Math.ceil(this.dealers.length / this.perPage);
      }
    },
    TerritoryItems () {
      if (this.Territories != null) {
        const items = [...this.territories];
        if (this.sortKey) {
          items.sort((a, b) => {
            const aVal = (a[this.sortKey] ?? '').toString().toLowerCase();
            const bVal = (b[this.sortKey] ?? '').toString().toLowerCase();
            if (aVal < bVal) {return this.sortDir === 'asc' ? -1 : 1;}
            if (aVal > bVal) {return this.sortDir === 'asc' ? 1 : -1;}
            return 0;
          });
        } else {
          items.sort((a, b) => b.territoryId - a.territoryId);
        }
        return items;
      }
    },
    DealerLevels () {
      const dealerStore = useDealerStore();
      return dealerStore.dealerLevels;
    }
    // PaginatedItems() {
    //   if (this.Dealers != null) {
    //     const startIndex = (this.currentPage - 1) * this.perPage;
    //     const endIndex = startIndex + this.perPage;
    //     return this.dealers.slice(startIndex, endIndex);
    //   }
    // }
  },
  methods: {
    handleSort (key) {
      if (this.sortKey === key) {
        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortKey = key;
        this.sortDir = 'asc';
      }
    },
    handleEditInputType (input) {
      useTerritoryStore().inputType = input;
    },
    handleActiveStatus (item) {
      const territoryStore = useTerritoryStore();
      item.isActive = item.isActive === true ? false : true;
      territoryStore.submitActiveStatus(item);
    },
    handleSearchResultClick (product) {
      this.selectedProduct = product;
      this.filterField.value = product;
      if (product === null) {
        this.dealers = this.Territories;
      } else {
        this.dealers = this.Territories.filter((item) => item.territoryId === product.id);
        this.savedDealers = this.dealers;
      }
    },
    handleInputValue (item) {
      let searchTxt = item.value.toLowerCase();
      // get the matching products
      this.dealers = this.savedDealers.filter((product) => {
        return product.name.toLowerCase().includes(searchTxt);
      });
    },
    handleEditTerritory (item) {
      const territoryStore = useTerritoryStore();
      territoryStore.tmpStates = useDealerStore().states;
      territoryStore.setSelectedTerritory(item);
      territoryStore.mode = 'edit';
      if (item != this.pastTerritory) {
        if (this.pastTerritory != null) {
          gsap.to('#territory-row-' + this.pastTerritory.territoryId, {
            backgroundColor: '#FFFFFF'
          });
        }
      }
      gsap.to('#territory-row-' + item.territoryId, {
        backgroundColor: '#D3d3d3'
      });
      // fill inputs
      territoryStore.territoryInputs.forEach((type) => {
        // if (type.field === 'territory') {
        //   const territory = this.DealerTerritories.find((el) => el.territoryId === item.territoryId);
        //   type.value = {
        //     id: territory.territoryId,
        //     name: territory.manager + ': ' + territory.territory,
        //     value: territory.territoryId
        //   };
        // } else if (type.field === 'state') {
        //   const state = this.States.find((el) => el.abbreviation == item.state);
        //   type.value = state;
        // } else if (type.field === 'country') {
        //   const currState = this.States.find((el) => el.abbreviation == item.state);
        //   const countryId = currState.countryId;
        //   const country = this.Countries.find((el) => el.countryId === countryId);
        //   type.value = country;
        // } else if (type.field === 'dealerLevel') {
        //   const dealerLevel = this.DealerLevels.find((el) => el.dealerLevelId === item.dealerLevelId);
        //   type.value = dealerLevel;
        // } else {
        //   type.value = item[type.field];
        // }
        if (type.field === 'state') {
          type.value = [];
          item.states.forEach((stateA) => {
            const state = this.States.find((el) => el.abbreviation == stateA);
            type.value.push(state);
            const tempStates = useTerritoryStore().tmpStates;
            useTerritoryStore().tmpStates = tempStates.filter((item) => item.name != state.name);
          });
          // const state = this.States.find((el) => el.abbreviation == item.state);
          // type.value = state;
        } else if (type.field === 'regions') {
          const findRegionName = useTerritoryStore().regions.find((el) => el.regionId === item.regionId);
          type.value = {
            id: item.regionId,
            name: findRegionName.region,
            value: item.regionId
          };
        }
          else {
          type.value = item[type.field];
        }
      });
              territoryStore.currentTerritory = item;
        this.pastTerritory = item;
      // const modalStore = useModalStore();
      // modalStore.showModal('edit');
      // modalStore.setModalObj(item);
    },
    handleDeleteTerritory (item) {
      this.removeTerritory = item;
      const modalStore = useModalStore();
      modalStore.showModal('prompt');
      modalStore.setModalObj({
        promptLabel: 'Remove ' + item.manager,
        promptDescription: 'Are you sure you want to remove this territory?',
        buttonALabel: 'Delete',
        buttonAFunc: this.handleDelete,
        buttonBLabel: 'Cancel',
        buttonBFunc: this.handleCancel,
      });
    },
    handleDelete () {
      const territoryStore = useTerritoryStore();
      territoryStore.removeTerritory(this.removeTerritory.territoryId);
      this.removeTerritory = null;
    },
    handleCancel () {
      useModalStore().hideModal();
    },
    handlePageChange (page) {
      this.currentPage = page;
    }
  }
};
</script>
<style scoped>
.territory-table-overlay-cont {
  max-height: 600px;
  overflow-y: auto;
}

th {
  font-size: 13px;
  font-weight: 550;
}

.tf-table {
  table-layout: fixed;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
th:nth-child(1) {
  width: 5%;
}
/* th:nth-child(2) {
width: 20%;
}
th:nth-child(3) {
width: 30%;
}
th:nth-child(4) {
  width: 15%;
}
th:nth-child(5) {
width: 20%;
}
th:nth-child(6) {
width: 20%;
}
th:nth-child(7) {
  width: 15%;
} */
 th:nth-child(3) {
width: 20%;
}
th:nth-child(8) {
width: 5%;
}
th:nth-child(9) {
width: 5%;
}
td {
  white-space: nowrap;
overflow: hidden;
  text-overflow: ellipsis;
}

.tf-table-header-row {
  top: 0;
  background-color: #fafafa;
  border-collapse: separate;
  position: sticky;
  width: 100%;
}

.tf-table-data-row {
  text-align: center;
  vertical-align: middle;
  font-size: small;
}

.tf-table-data-row:hover {
  background-color: lightgray;
}

.tf-table-data-edit-icon {
  cursor: pointer;
  width: 20px;
}

.tf-table-data-delete-icon {
  cursor: pointer;
  width: 20px;
}
.tf-table-data-checkbox {
  width:16px;
  height: 16px;
  cursor: pointer;
}
th, td {
  padding: 5px;
}
.tf-table-dropdown {
  max-width: 440px;
}
.tf-table-data-input {
  max-width: 700px;
}
/* .tf-header-text-title {
  width: 60%;
} */
.tf-header-text-edit, .tf-header-text-del {
  width: 20%;
}
.sortable {
  cursor: pointer;
  user-select: none;
}
.sortable:hover {
  background-color: #efefef;
}
.sort-active {
  background-color: #e8e8e8;
}
.sort-arrow {
  font-size: 10px;
  margin-left: 4px;
}
</style>